export default __webpack_public_path__ + "90da7ab18293ca42e335a6fdf8f3371c.ttf";